// extracted by mini-css-extract-plugin
export default {"root":"Htabs_root__61h63"};